import { Pipe, PipeTransform } from '@angular/core';
import { DreSection } from '../../../../data/src/lib/entities/chart-of-accounts.model';

const DRE_SECTION_TRANSLATE_KEYS: Record<DreSection, string> = {
  [DreSection.GrossRevenue]: 'TREASURY.CHART_OF_ACCOUNTS.DRE_SECTION.GROSS_REVENUE',
  [DreSection.RevenueDeduction]: 'TREASURY.CHART_OF_ACCOUNTS.DRE_SECTION.REVENUE_DEDUCTION',
  [DreSection.CostOfServices]: 'TREASURY.CHART_OF_ACCOUNTS.DRE_SECTION.COST_OF_SERVICES',
  [DreSection.OperatingExpenses]: 'TREASURY.CHART_OF_ACCOUNTS.DRE_SECTION.OPERATING_EXPENSES',
  [DreSection.FinancialItems]: 'TREASURY.CHART_OF_ACCOUNTS.DRE_SECTION.FINANCIAL_ITEMS',
};

@Pipe({ name: 'chartOfAccountsDreSectionKey', standalone: true, pure: true })
export class ChartOfAccountsDreSectionKeyPipe implements PipeTransform {
  public transform(value: DreSection): string {
    return DRE_SECTION_TRANSLATE_KEYS[value];
  }
}
